"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutputService = void 0;
class OutputService {
    static print(selector) {
        OutputService.initPrint();
        const printContents = document.querySelector(selector).outerHTML;
        OutputService.printShow.innerHTML = printContents;
        window.print();
    }
    static initPrint() {
        if (OutputService.printInitted) {
            return;
        }
        const style = document.createElement('style');
        style.innerHTML = `
      .print-show {
        display: none;
      }
      @media print {
        .print-ignore {
          display: none;
        }
        .print-show {
          display: block;
        }
      }
    `;
        document.head.appendChild(style);
        OutputService.printInitted = true;
        const printIgnore = document.createElement('div');
        printIgnore.classList.add('print-ignore');
        document.body.append(printIgnore);
        [...document.body.childNodes].forEach((node) => {
            if (node !== printIgnore) {
                printIgnore.append(node);
            }
        });
        OutputService.printShow = document.createElement('div');
        OutputService.printShow.classList.add('print-show');
        document.body.append(OutputService.printShow);
    }
    static download(selector, width, height, fileName) {
        const element = document.querySelector(selector);
        OutputService.initDownload().then(() => {
            const scale = window.devicePixelRatio;
            window['html2canvas'](element, {
                width,
                height,
                scale,
                onclone: (doc) => {
                    doc.body.style.width = `${width}px`;
                    doc.body.style.height = `${height}px`;
                    doc.body.classList.add('download');
                },
                ignoreElements: (element) => {
                    return element.classList.contains('no-print');
                },
            }).then((canvas) => {
                const imgData = canvas.toDataURL('image/png');
                const pxToPt = (px) => px * (72 / 96);
                const pdf = new window['jspdf'].jsPDF({
                    unit: 'pt',
                    orientation: width > height ? 'l' : 'p',
                    format: [pxToPt(width / scale), pxToPt(height / scale)],
                });
                pdf.addImage(imgData, 'PNG', 0, 0, pxToPt(width / scale), pxToPt(height / scale));
                pdf.save(fileName);
            });
        });
    }
    static initDownload() {
        if (OutputService.downloadInitted) {
            return Promise.resolve();
        }
        const promise = new Promise((resolve, reject) => {
            const checkIfDone = () => {
                if (script1Loaded && script2Loaded) {
                    OutputService.downloadInitted = true;
                    resolve();
                }
            };
            let script1Loaded = false;
            const script1 = document.createElement('script');
            script1.type = 'text/javascript';
            script1.src =
                'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
            script1.onload = () => {
                script1Loaded = true;
                checkIfDone();
            };
            script1.onerror = () => {
                alert('Unable to load printing scrpt.');
                reject();
            };
            let script2Loaded = false;
            const script2 = document.createElement('script');
            script2.type = 'text/javascript';
            script2.src =
                'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js';
            script2.onload = () => {
                script2Loaded = true;
                checkIfDone();
            };
            script2.onerror = () => {
                reject();
            };
            document.head.appendChild(script1);
            document.head.appendChild(script2);
        });
        return promise;
    }
}
exports.OutputService = OutputService;
OutputService.printInitted = false;
OutputService.downloadInitted = false;
